import React from 'react';

import { MainWrapper, Section, Reveal, Button } from '../../shared';
import { getIcon } from '../../shared/icons/iconMap';
import { useSettings } from '../../../context/SettingsContext';
import danielPhoto from '../../../imgs/daniel.jpeg';

import './AboutPage.scss';

export function AboutPage() {
  const { t } = useSettings();
  const a = t.about;

  return (
    <MainWrapper currentPageName="About" headerPageText={a.headerTitle} eyebrow={a.eyebrow} intro={a.intro}>
      {/* Intro */}
      <Section ariaLabel={a.headerTitle}>
        <div className="about">
          <Reveal className="about__portrait">
            <img className="about__photo" src={danielPhoto} alt={a.photoAlt} width={640} height={640} />
          </Reveal>
          <Reveal delay={0.1} className="about__copy">
            {a.paras.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </Reveal>
        </div>
      </Section>

      {/* Why monthly */}
      <Section tint ariaLabel={a.why.title}>
        <div className="why">
          <Reveal className="why__copy">
            <span className="ds-eyebrow">{a.why.eyebrow}</span>
            <h2>{a.why.title}</h2>
            <p>{a.why.body1}</p>
            <p>{a.why.body2}</p>
            <Button to="/services" variant="ghost">
              {a.why.link}
            </Button>
          </Reveal>
          <Reveal delay={0.1} className="why__stats">
            {a.stats.map((stat) => (
              <div className="stat" key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </Reveal>
        </div>
      </Section>

      {/* Process */}
      <Section ariaLabel={a.processTitle}>
        <Reveal>
          <span className="ds-eyebrow">{a.processEyebrow}</span>
          <h2 className="section-title">{a.processTitle}</h2>
        </Reveal>
        <ol className="about-steps">
          {t.process.map((step, i) => (
            <Reveal as="li" key={step.title} delay={i * 0.06} className="about-steps__item ds-card">
              <span className="about-steps__icon">{getIcon(step.icon)}</span>
              <span className="about-steps__num">
                {a.stepLabel} {i + 1}
              </span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </Reveal>
          ))}
        </ol>
      </Section>

      {/* CTA */}
      <Section tint ariaLabel={a.cta.title}>
        <Reveal className="about-cta">
          <h2>{a.cta.title}</h2>
          <p>{a.cta.body}</p>
          <Button to="/contact">{a.cta.button}</Button>
        </Reveal>
      </Section>
    </MainWrapper>
  );
}

export default AboutPage;
